import { iProState } from "../../interfaces/interfaces";
import { tProAction, eProActionTypes } from "./proTypes";

const initialState: iProState = {
	currentFToken: null,
	currentUToken: null,
	currentMaturityDate: null,
	// options_period: 'weekly',
	optionsPeriod: 'daily',
}

export const proReducer = ( state = initialState, action: tProAction) : iProState => {
	switch (action.type) {

		case eProActionTypes.SET_CURRENT_F_TOKEN:
			return {...state, currentFToken: action.payload};

		case eProActionTypes.SET_CURRENT_U_TOKEN:
			return {...state, currentUToken: action.payload};

		case eProActionTypes.SET_CURRENT_MATURITY_DATE:
			return {...state, currentMaturityDate: action.payload};

		case eProActionTypes.CLEAR_STATE:
			return initialState;

		case eProActionTypes.SET_OPTIONS_PERIOD:
			return {...state, optionsPeriod: action.payload};

		default:
			return state;
	}
}